<template>
        <a :href="href" class="h-full block group md:shadow-card bg-blue-50 pt-12 pb-8 px-8 text-center rounded-lg duration-100 hover:shadow-cardHigh focus:shadow-cardHigh  hover:bg-blue-100 focus:bg-blue-100 hover:-mt-1 focus:-mt-1 focus:outline-none ">
            <div class="text-blue-300">
                <slot name="image"></slot>
                <h3 class="font-semibold text-gray-800 text-xl mb-2">{{ title }}</h3>
                <slot></slot>

                <svg class="stroke-current duration-100 group-hover:text-blue-700 group-focus:text-blue-700 text-gray-200 h-4 mx-auto mt-6"
                     viewBox="0 0 70 21"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <rect y="15"
                          width="63"
                          height="6"
                          fill="#FFD705"
                          stroke-width="0"
                          class="opacity-0 group-hover:opacity-100 group-focus:opacity-100 duration-100"/>
                    <path d="M12.5 15H66L53 2"
                          stroke-width="3"/>
                </svg>

            </div>
        </a>
</template>

<script>
    export default {
        name: "card",
        props: [
            'title',
            'href']
    }
</script>

<style scoped>

</style>
